import React from "react";
import {
    SoulStyleContainer,
    Container,
    ImageContainer,
    Link,
    Details,
    Span,
    Header,
    Text,
} from "../../styles/SoulStyle";

// img
import footerBottomImg from "assets/images/footet-bottom.jpg";

function SoulStyle(props) {
    return (
        <SoulStyleContainer>
            <Container className="container-fluid">
                <ImageContainer>
                    <Link>
                        <img
                            src={footerBottomImg}
                            alt="img"
                            className="img-fluid"
                        />
                        <Details>
                            <Span>#soulstyle</Span>
                            <Header>
                                Tips and tricks from our seasoned designers on
                                how to best use our products
                            </Header>
                            <Text>
                                Follow us on Instagram @ruhlisticdecor for some
                                nifty ideas and latest product photos{" "}
                            </Text>
                        </Details>
                    </Link>
                </ImageContainer>
            </Container>
        </SoulStyleContainer>
    );
}

export default SoulStyle;
